/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import { apiFetch } from '../../../apiClient';
import { apiMap, settings } from '../../../config/constants';
import { getSessionDatas } from '../../../utils'
import { saveAppInfo, showLoaing, handleInputError } from '../../App/state/action'

export const retrvBussiness = () => dispatch => {
    const businessParams = {
        hostname: settings.hostBusiness,
        method: settings.get
    };
    return apiFetch(apiMap.getBusinessInfo(getSessionDatas().applicationId), businessParams)(dispatch);
}
export const unfrozenApp = (applicationInfo,referenceCode, callBack) => dispatch => {
  const paramsDatas = {
    "applicationId": getSessionDatas().applicationId,
    "referenceCode": referenceCode
  };
  dispatch(showLoaing(true));
  apiFetch(apiMap.unfrozen, {
    method: settings.post,
    hostname: settings.hostnameSubmit,
    paramsObj: paramsDatas
  })(dispatch).then((result) => {
      dispatch(showLoaing(false));
      applicationInfo.status = 4;
      dispatch(saveAppInfo(applicationInfo));
      callBack();
  }).catch( error => {
      dispatch(showLoaing(false));
      error && dispatch(handleInputError(true,error.errorCode));
  });
}



// WEBPACK FOOTER //
// ./src/views/Appointment/state/action.js